{
	"title": "Carbon buffer settings",
	"tooltip": "Buffer volume = 10% of total deposits.",
	"adjust": "Adjust",
	"totalCarbonBuffer": "Total carbon buffer",
	"fossilBuffer": "Fossil buffer",
	"biogenicBuffer": "Biogenic buffer"
}
